<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="设备管理" CMname="地图展示" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item label="地铁站：">
						<el-select v-model="searchform.siteid" placeholder="请选择" >
							<el-option v-for="item in siteidData" :key="item.SiteId":label="item.SiteName" :value="item.SiteId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="table">
				<div id="SXMap_Div" >
					<el-amap ref="map" vid="amapDemo" 
						:center="center" 
						:zoom="zoom"  
						:events="events" class="sxamap">
					<el-amap-marker v-for="(marker, index) in markers" 
					:position="marker.position" 
					:events="marker.events" 
					:visible="marker.visible" 
					:draggable="marker.draggable" 
					:vid="index"></el-amap-marker>
					</el-amap>
				</div>
			</template>
		</HrrMainLayout>
	</div>	
</template>
<script>
	export default {
		name: 'site_map',
		data(){
			return{
				searchform:{
					siteid:"",
				},
				keyword:"",
				selectfield:"postTitle",
				zoom: 11,
				center: [121.59996, 31.197646],
				events: {
					init: (o) => {
					  console.log(o.getCenter())
					  console.log(this.$refs.map.$$getInstance())
					  o.getCity(result => {
					    console.log(result)
					  })
					},
					'moveend': () => {
					},
					'zoomchange': () => {
					},
					'click': (e) => {
					  alert('map clicked');
					}
				},
				markers:[],
			    siteidData:[],
			    SiteAllData:[]
			}
		},
		methods:{
			onSubmit(){
				this.initData();
			},
			getMap() {
	          // amap vue component
	          console.log(this.AMapManager._componentMap);
	          // gaode map instance
	          console.log(this.AMapManager._map);
	        },
			initData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.site.all)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.SiteAllData=data.Data;
						Vuethis.initMark();
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			initMark(){
				var Vuethis=this;
				this.SiteAllData.forEach(function(e, index) {
					var marker={
						position:[e.Lon,e.Lat],
						events: {
			                click: () => {
			                  alert('click marker');
			                },
			                dragend: (e) => {
			                  console.log('---event---: dragend')
			                  console.log(e);
			                }
			            },
			            visible: true,
			            template: '<span>'+e.Site_Name+'</span>'
					};
					Vuethis.markers.push(marker);
				});
			},
			initParamsData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.site.downlist)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.siteidData=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			next();
		},
		created(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style>
   #SXMap_Div{height: 620px;width:100%;}
  .sxamap{height:100%;width:100%;}
</style>
